import type { SetupNextStep } from '../../api.ts'

// Every setup/*.tsx action() redirects based on the `nextStep` the API computes from the
// updated session, rather than a hardcoded "my step + 1" — that's what lets
// POST /api/setup/kind route straight to /setup/basics for a "creator" kind and to
// /setup/music for a "music" kind without the client re-implementing that branching.
// Note: GET/POST /api/setup never reports "complete" (see routes/setup/_layout.tsx's loader
// for why) — the `default` branch below only exists as a defensive fallback.
export function pathForStep(step: SetupNextStep): string {
  switch (step) {
    case 'kind':
      return '/setup/kind'
    case 'music':
      return '/setup/music'
    case 'basics':
      return '/setup/basics'
    case 'pacing':
      return '/setup/pacing'
    case 'voice':
      return '/setup/voice'
    case 'publishing':
      return '/setup/publishing'
    case 'exemplars':
      return '/setup/exemplars'
    default:
      return '/'
  }
}
